import { useState, useEffect } from 'react';
import NaviBar from '../NaviBar/NaviBar';
import SearchBar from '../NaviBar/SearchBar';
import Cookies from 'js-cookie';
import { currencyStyle } from '../../services/methods';
import { currencyOptions } from '../../staticData/options';
import 'animate.css';
import BottomCard from '../ShoppingCart/BottomCart';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AddIcon } from '../../Icons/add-quantity-icon.svg';
import { ReactComponent as DecreIcon } from '../../Icons/decrease-qtt.svg';
import { ReactComponent as ZoomIn } from '../../Icons/right-out.svg';
import { ReactComponent as ZoomOut } from '../../Icons/left-in.svg';
import { PlayCircleOutline } from '@material-ui/icons';
import { Modal } from 'react-bootstrap';
import { motion } from 'framer-motion';
import 'animate.css';
import { buttonVariants } from '../../items/animation';

function arraymove(arr, fromIndex, toIndex) {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}

function DescriptionPage(props) {
  const [isAnimating, setIsAnimating] = useState(false);
  const isHello = localStorage.getItem('HELLO_FRESH') === 'TRUE';
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { t } = useTranslation();
  const {
    products,
    cleanUp,
    setLoading,
    cart,
    promoRef,
    decreStock,
    langs,
    showCart,
    remove,
    alterquantity,
    add,
    setShowCart,
    setlangs,
    stat,
    setStat,
    changePrice,
    audio,
    stopPlay,
    HFuser,
    clientUser,
    setClientUser,
  } = props;

  let prods = JSON.parse(localStorage.getItem('products'));
  let machine = JSON.parse(localStorage.getItem('machine'));
  let symbol = machine?.currency?.symbol;
  let addToCartStyle = machine?.themeColor?.addToCartStyle;
  symbol = symbol ? symbol : '$';
  const idx = props.i;
  //get image url from productPicture
  const newImage = [];

  const getLocalBasePath = () => {
    if (prods[idx].prodType === 'fridge1' || prods[idx].prodType === 'fridge2') {
      return `${process.env.REACT_APP_LOCAL_API}/pictures/fridge/`;
    }
    return `${process.env.REACT_APP_LOCAL_API}/pictures/products/`;
  };

  prods[idx].productPictures.forEach((element) => {
    if (element !== '') {
      newImage.push(
        isLocal
          ? `${getLocalBasePath()}${element}`
          : `${process.env.REACT_APP_SERVER_API}/pictures/${element}/${prods[idx].referTo}`
      );
    }
  });

  // const [pictures, setPictures] = useState(newImage);
  const [curr, setCurr] = useState(0);

  const [mainL, setMainL] = useState('en-US');
  const [show, setShow] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [active, setActive] = useState(0);
  const [more, setMore] = useState(true);
  const [more1, setMore1] = useState(true);
  const [more2, setMore2] = useState(true);
  const [index, setIndex] = useState(0);

  let addToCartText = t('ADD TO CART');
  if (addToCartStyle === '1') addToCartText = t('ADD TO BAG');
  // console.log(prods[idx]);
  console.log('descpageproduct', prods);
  console.log('descpageproduct', idx);
  console.log('descpageproduct', prods[idx]);
  const FTitle1 =
    prods[idx].title1 && prods[idx].title1[langs] && prods[idx].title1[langs] !== ''
      ? prods[idx].title1[langs]
      : prods[idx].title1?.en;
  const FTitle2 =
    prods[idx].title2 && prods[idx].title2[langs] && prods[idx].title2[langs] !== ''
      ? prods[idx].title2[langs]
      : prods[idx].title2?.en;

  const FName =
    prods[idx].name[langs] && prods[idx].name[langs] !== ''
      ? prods[idx].name[langs]
      : prods[idx].name?.en;
  const FDesc =
    prods[idx].description && prods[idx].description[langs] && prods[idx].description[langs] !== ''
      ? prods[idx].description[langs]
      : prods[idx].description?.en;
  const FKeyf =
    prods[idx].keyFeatures && prods[idx].keyFeatures[langs] && prods[idx].keyFeatures[langs] !== ''
      ? prods[idx].keyFeatures[langs]
      : prods[idx].keyFeatures?.en;
  const Fdetail =
    prods[idx].detail && prods[idx].detail[langs] && prods[idx].detail[langs] !== ''
      ? prods[idx].detail[langs]
      : prods[idx].detail?.en;
  // const FSpec =
  //   prods[idx].specification &&
  //   prods[idx].specification[langs] &&
  //   prods[idx].specification[langs] !== ''
  //     ? prods[idx].specification[langs]
  //     : prods[idx].specification?.en;
  // const FInclude =
  //   prods[idx].include && prods[idx].include[langs] && prods[idx].include[langs] !== ''
  //     ? prods[idx].include[langs]
  //     : prods[idx].include?.en;

  const FSpec =
    prods[idx].ingredients && prods[idx].ingredients[langs] && prods[idx].ingredients[langs] !== ''
      ? prods[idx].ingredients[langs]
      : prods[idx].ingredients?.en;
  const FInclude =
    prods[idx].allergens && prods[idx].allergens[langs] && prods[idx].allergens[langs] !== ''
      ? prods[idx].allergens[langs]
      : prods[idx].allergens?.en;

  const today = new Date();

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    } else if (mycoockie === 'zh') {
      setMainL('zh-CN');
    }
  }, []);

  //count description page
  useEffect(() => {
    const index = stat?.prod.findIndex((item) => item._id === prods[idx]._id);
    if (index >= 0) {
      stat.prod[index].detail = stat.prod[index].detail += 1;
    } else {
      stat.prod.push({
        _id: prods[idx]._id,
        name: prods[idx].name?.en,
        detail: 1,
        specs: 0,
        includes: 0,
        add_to_cart: 0,
        conv: 0,
      });
    }
    setStat(stat);
  }, []);

  //count spec page
  useEffect(() => {
    const index = stat?.prod.findIndex((item) => item._id === prods[idx]._id);
    if (index >= 0) {
      if (active !== 0) {
        if (active === 1) {
          stat.prod[index].specs = stat.prod[index].specs += 1;
        }
        if (active === 2) {
          stat.prod[index].includes = stat.prod[index].includes += 1;
        }
        setStat(stat);
      }
    }
    console.log(stat);
  }, [active]);

  useEffect(() => {
    if (props.cart.length > 0) {
      const index = props.cart?.findIndex((item) => item.id === prods[idx]._id);
      if (index >= 0) {
        setQuantity(props.cart[index].quantity);
      } else {
        setQuantity(0);
      }
    } else {
      setQuantity(0);
    }
    return () => {};
  }, [cart]);

  // const clickImg = (index) => {
  //   const array = [...pictures];
  //   arraymove(array, index, 0);
  //   console.log(array);
  //   setPictures(array);
  // };

  function imageSlider(e) {
    return <img alt="" src={newImage[0]} />;
  }

  const leftFunction = () => {
    const index = curr === 0 ? newImage.length - 1 : curr - 1;
    setCurr(index);
  };

  const rightFunction = () => {
    const index = curr >= newImage.length - 1 ? 0 : curr + 1;
    setCurr(index);
  };

  function imageSlider(e) {
    // Helper function to get the correct base path for local URLs

    if (e == 'small') {
      if (index === prods[idx].productPictures.length) {
        return (
          <video
            className="desc-main-image"
            alt="product-image"
            onClick={() => setShow(true)}
            src={
              isLocal
                ? `${getLocalBasePath()}${prods[idx].productVideo}`
                : `${process.env.REACT_APP_SERVER_API}/videos/${prods[idx].productVideo}/${prods[idx].referTo}`
            }
            autoPlay
          ></video>
        );
      } else
        return (
          <img
            key={index}
            src={
              isLocal
                ? `${getLocalBasePath()}${prods[idx].productPictures[index]}`
                : `${process.env.REACT_APP_SERVER_API}/pictures/${prods[idx].productPictures[index]}/${prods[idx].referTo}`
            }
            onClick={() => setShow(true)}
            alt="product-image"
            className="desc-main-image"
          />
        );
    } else {
      if (index === prods[idx].productPictures.length) {
        return (
          // <div className="outter-desc-modal d-flex justify-content-center align-items-center">
          <video
            onClick={() => setShow(false)}
            className="desc-modal-image"
            src={
              isLocal
                ? `${getLocalBasePath()}${prods[idx].productVideo}`
                : `${process.env.REACT_APP_SERVER_API}/videos/${prods[idx].productVideo}/${prods[idx].referTo}`
            }
            autoPlay
          ></video>
          // </div>
        );
      } else
        return (
          // <div className="outter-desc-modal d-flex justify-content-center align-items-center">
          <img
            onClick={() => setShow(false)}
            key={index}
            src={
              isLocal
                ? `${getLocalBasePath()}${prods[idx].productPictures[index]}`
                : `${process.env.REACT_APP_SERVER_API}/pictures/${prods[idx].productPictures[index]}/${prods[idx].referTo}`
            }
            alt="product-image"
            className="desc-modal-image"
          />
          //  </div>
        );
    }
  }

  const pictures = prods[idx].productPictures.map((picture, i) => {
    return (
      <div
        key={i}
        className={`d-flex flex-column justify-content-center align-items-center  ${
          index === i ? 'product-image-active' : ''
        }`}
        style={{
          height: '120px',
          width: '120px',
          // backgroundColor: 'white',
          marginLeft: '1em',
          marginRight: '1em',
        }}
      >
        {prods[idx].current_stock == 0 && <div className="crossLine"></div>}
        <img
          onClick={() => {
            if (index !== i) {
              setIndex(i);
            }
          }}
          style={{
            maxHeight: '90%',
            maxWidth: '90%',
          }}
          key={picture}
          src={
            isLocal
              ? `${getLocalBasePath()}${picture}`
              : `${process.env.REACT_APP_SERVER_API}/pictures/${picture}/${prods[idx].referTo}`
          }
          alt="picture"
        />
      </div>
    );
  });

  const customStyles = () => {
    if (!FTitle1 && !FTitle2) {
      // console.log('222');
      return (
        <div className="desc-overview-div desc-overview-div-v1 text-product-color">
          <div
            className={active === 0 ? 'desc-active' : ''}
            onClick={() => {
              setActive(0);
            }}
          >
            {/* <div> {t(`Overview`)}</div> */}
            <div className="desc-line"></div>
          </div>
        </div>
      );
    } else {
      if (!FTitle1 || !FTitle2) {
        console.log('222222');
        return (
          <div className="desc-overview-div  desc-overview-div-v2 text-product-color">
            <div
              className={active === 0 ? 'desc-active' : ''}
              onClick={() => {
                setActive(0);
              }}
            >
              <div> {t(`Overview`)}</div>
              <div className="desc-line"></div>
            </div>
            {FTitle1 && (
              <div
                className={active === 1 ? 'desc-active' : ''}
                onClick={() => {
                  setActive(1);
                }}
              >
                <div>{FTitle1}</div>
                <div className="desc-line"></div>
              </div>
            )}
            {FTitle2 && (
              <div
                className={active === 2 ? 'desc-active' : ''}
                onClick={() => {
                  setActive(2);
                }}
              >
                <div>{FTitle2}</div>
                <div className="desc-line"></div>
              </div>
            )}
          </div>
        );
      }
    }
    return (
      <div className="desc-overview-div text-product-color">
        <div
          className={active === 0 ? 'desc-active' : ''}
          onClick={() => {
            setActive(0);
          }}
        >
          <div> {t(`Overview`)}</div>
          <div className="desc-line"></div>
        </div>
        <div
          className={active === 1 ? 'desc-active' : ''}
          onClick={() => {
            setActive(1);
          }}
        >
          <div>{FTitle1}</div>
          <div className="desc-line"></div>
        </div>
        <div
          className={active === 2 ? 'desc-active' : ''}
          onClick={() => {
            setActive(2);
          }}
        >
          <div>{FTitle2}</div>
          <div className="desc-line"></div>
        </div>
      </div>
    );
  };

  function calculateItemPrice() {
    if (prods[idx].buyX) {
      console.log('11111111111');
      if (prods[idx].percentage) {
        const details = `<p class="card-product-title"><span style="color: red; font-size: 1.5rem;">${t(
          'Buy'
        ).toUpperCase()} ${prods[idx].buyX} ${t('Or').toUpperCase()} ${t('More').toUpperCase()} ${
          prods[idx].name[langs]
        }, ${t('Get').toUpperCase()} ${prods[idx].amount * 100}% ${t(
          'Off'
        ).toUpperCase()}! </span></p>`;
        return (
          <div>
            <span style={{ margin: 0 }}>
              {currencyStyle(
                langs,
                symbol,
                prods[idx].price.toLocaleString(mainL, currencyOptions)
              )}
            </span>
            &nbsp;&nbsp;
          </div>
        );
      } else {
        return (
          <div>
            <span style={{ margin: 0 }}>
              {currencyStyle(
                langs,
                symbol,
                prods[idx].price.toLocaleString(mainL, currencyOptions)
              )}
            </span>
            &nbsp;&nbsp;{' '}
            <span style={{ margin: 0, color: 'red', textDecoration: 'underline dotted' }}>
              {t('Promo')}
            </span>
          </div>
        );

        // return <span>${props.price} - <span style={{color: 'red'}}>{t('Promo')}!</span></span>
      }
    } else if (
      prods[idx].discountedPrice != null &&
      prods[idx].discountedPrice !== prods[idx].price
    ) {
      return (
        <div>
          <span>
            <del>
              {currencyStyle(
                langs,
                symbol,
                prods[idx].price?.toLocaleString(mainL, currencyOptions)
              )}
            </del>

            <span style={{ color: 'red' }}>
              &nbsp;&nbsp;
              {currencyStyle(
                langs,
                symbol,
                prods[idx].discountedPrice?.toLocaleString(mainL, currencyOptions)
              )}
            </span>
          </span>
        </div>
      );
    } else {
      return (
        <div>
          {currencyStyle(langs, symbol, prods[idx].price.toLocaleString(mainL, currencyOptions))}
        </div>
      );
    }
  }

  const getPrice = () => {
    if (prods[idx].discountedPrice && prods[idx].buyX > 1) return prods[idx].price;
    else if (prods[idx].discountedPrice) return prods[idx].discountedPrice;
    else return prods[idx].price;
  };

  const splitTheContent = (content) => {
    if (content) {
      const array = content.split(';');
      const result = array.map((e, i) => {
        return <div key={i}>{e}</div>;
      });

      return result;
    }
  };

  const addToCart = async (e) => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 800);
    const index = props.cart?.findIndex((item) => item.id === prods[idx]._id);
    if (prods[idx].current_stock > 0) {
      props.decreStock(prods[idx], prods[idx].current_stock - 1);
      if (
        prods[idx].plan &&
        Date.parse(prods[idx].plan.start) <= today &&
        Date.parse(prods[idx].plan.end) >= today
      ) {
        // setShowp(true);
        // setmyprod(props.prod);
      }
      if (index >= 0) {
        props.alterquantity({ id: prods[idx]._id }, cart[index].quantity + 1);
      } else {
        props.add({
          idx: parseInt(prods[idx].idx),
          id: prods[idx]._id,
          _id: prods[idx]._id,
          key: prods[idx]._id,
          limit: prods[idx].limit,
          upc: prods[idx]?.upc,
          name: prods[idx].name,
          title: prods[idx].name,
          promo: prods[idx].promo,
          price: prods[idx].price,
          discount: prods[idx].discount ? prods[idx].discount : 0,
          percentage: prods[idx].percentage,
          discountedPrice: prods[idx].discountedPrice ?? prods[idx].price,
          image: prods[idx].productPictures[0],
          buyX: prods[idx].buyX ? prods[idx].buyX : 0,
          quantity: 1,
          category: prods[idx].category,
          ingredients: prods[idx].ingredients,
          referTo: prods[idx].referTo,
          prodType: prods[idx].prodType,
          current_stock: prods[idx].current_stock,
          emailCode: prods[idx].emailCode,
          addition: prods[idx].addition,
          tax_type: prods[idx].tax_type,
          pop_alert: prods[idx].pop_alert,
          bundle_prod: prods[idx].bundle_prod,
        });
      }
    }
  };

  const setShowMore = () => {
    more ? setMore(false) : setMore(true);
  };
  const setShowMore1 = () => {
    more1 ? setMore1(false) : setMore1(true);
  };
  const setShowMore2 = () => {
    more2 ? setMore2(false) : setMore2(true);
  };

  const selfDecreStock = () => {
    decreStock(prods[idx], prods[idx].current_stock + 1);
    if (quantity == 1) {
      props.remove({ id: prods[idx]._id });
    } else if (quantity > 1) {
      const index = props.cart?.findIndex((item) => item.id === prods[idx]._id);
      props.alterquantity({ id: prods[idx]._id }, props.cart[index].quantity - 1);
    }
  };

  return (
    <div className="main-container">
      <div className="Navi"></div>
      <NaviBar
        products={products}
        cleanUp={cleanUp}
        add={add}
        alterquantity={alterquantity}
        decreStock={decreStock}
        langs={langs}
        setLoading={setLoading}
        setShowCart={setShowCart}
        setlangs={setlangs}
        cart={cart}
        setClientUser={setClientUser}
        clientUser={clientUser}
        showGoBack={true}
      />
      <SearchBar langs={langs} />
      <div className="decription-page">
        <div className="desc-main-image-div">
          {/* <img alt="" className="desc-main-image" src={newImage[curr]}></img> */}
          {imageSlider('small')}
          <div className="desc-second-image-container mb-5 mt-3">
            {/* {newImage?.length > 1 && (
              <div className="desc-second-image-div" style={{ marginRight: '-25px' }}>
                <ZoomIn className="desc-zoom-icon" onClick={leftFunction}></ZoomIn>
              </div>
            )} */}
            <div className="d-flex justify-content-center">
              {pictures}
              {prods[idx].productVideo && (
                <div>
                  {prods[idx].current_stock == 0 && <div className="crossLine2"></div>}
                  <div
                    className={`d-flex justify-content-center align-content-center align-items-center  ${
                      index === prods[idx].productPictures.length && 'product-image-active'
                    }`}
                    onClick={() => setIndex(prods[idx].productPictures.length)}
                    style={{
                      height: '120px',
                      width: '120px',
                      marginLeft: '1em',
                      marginRight: '1em',
                      // backgroundColor: 'lightgrey',
                    }}
                  >
                    <PlayCircleOutline className="play_icon_div" style={{ fontSize: '80px' }} />
                  </div>
                </div>
              )}
            </div>

            {/* {newImage?.length >= 1 && (
              <div className="desc-second-image-div">
                <img alt="" className="desc-second-image" src={pictures[curr]}></img>
              </div>
            )}

            {newImage?.length > 1 && (
              <div className="desc-second-image-div">
                <img
                  alt=""
                  className="desc-second-image"
                  src={pictures[curr >= newImage.length - 1 ? 0 : curr + 1]}
                ></img>
              </div>
            )}

            {newImage?.length > 1 && (
              <div className="desc-second-image-div" style={{ marginLeft: '-25px' }}>
                <ZoomOut className="desc-zoom-icon" onClick={rightFunction}></ZoomOut>
              </div>
            )} */}
          </div>
          <div className={FName ? 'desc-name-20' : 'desc-name'}>{FName}</div>
          {prods[idx].detail && <div className="desc-detail">{Fdetail}</div>}

          <div className="desc-price">{calculateItemPrice()}</div>
          {prods[idx].limit ? <div className="desc-price">Limit: {prods[idx].limit}</div> : null}

          {quantity === 0 ? (
            prods[idx].current_stock > 0 ? (
              <div className="view-more-button desc-addtocart" onClick={addToCart}>
                {addToCartText}
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center">
                <div className="desc-product-soldout d-flex align-items-center justify-content-center">
                  <span className="desc-product-soldout-text">{t(`SOLD OUT`)}</span>
                </div>
              </div>
            )
          ) : (
            <div className="desc-product-add-remove-div d-flex align-items-center justify-content-center">
              {quantity > 0 && (
                <DecreIcon className="desc-addtocartimage" onClick={selfDecreStock} />
              )}
              {quantity > 0 && (
                <motion.div
                  className="desc-product-quantity d-flex align-items-center justify-content-center"
                  variants={buttonVariants}
                  animate={isAnimating ? 'animate' : 'normal'}
                >
                  <span className="desc-product-quantity-text">{quantity}</span>
                </motion.div>
              )}
              {prods[idx].current_stock > 0 ? (
                <AddIcon
                  className="desc-addtocartimage"
                  onClick={() => {
                    addToCart();
                  }}
                />
              ) : (
                <div className="desc-addtocartimage"></div>
              )}
            </div>
          )}

          {customStyles()}

          {active === 0 && FDesc && FDesc !== '' && (
            <div>
              <div className="desc-desc-div text-product-color">
                <div className="desc-desc-text">{t(`Description`)}</div>
                <div
                  // className={more ? 'desc-desc-subtext' : 'desc-desc-subtext-1'}
                  className="desc-desc-subtext desc-desc-height"
                  onClick={setShowMore}
                >
                  {FDesc}
                </div>
              </div>
              {/* {prods[idx].keyFeatures && FKeyf && FKeyf !== '' && (
                <div>
                  <div className="desc-desc-text">{t(`Key Features`)}</div>
                  <div
                    className={more1 ? 'desc-desc-subtext2' : 'desc-desc-subtext-1'}
                    onClick={setShowMore1}
                  >
                    {splitTheContent(FKeyf)}
                  </div>
                </div>
              )} */}
            </div>
          )}
          {active === 1 && prods[idx].specification && FSpec && FSpec !== '' && (
            <div>
              <div className="desc-desc-text text-product-color">{FTitle1}</div>
              {prods[idx].specification && (
                <div
                  className={more2 ? 'desc-desc-subtext3' : 'desc-desc-subtext-1'}
                  onClick={setShowMore2}
                >
                  {splitTheContent(FSpec)}
                </div>
              )}
            </div>
          )}
          {active === 2 && prods[idx].include && FInclude && FInclude !== '' && (
            <div>
              <div className="desc-desc-text text-product-color">{FTitle2}</div>
              {prods[idx].include && (
                <div
                  className={more2 ? 'desc-desc-subtext3' : 'desc-desc-subtext-1'}
                  onClick={setShowMore2}
                >
                  {splitTheContent(FInclude)}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <Modal
        className="animate__animated animate__zoomInDownz animate__zoomInz"
        id="desc-modal"
        show={show}
        onHide={() => setShow(false)}
        centered
      >
        {imageSlider()}
      </Modal>
      <BottomCard
        cleanUp={cleanUp}
        clientUser={clientUser}
        setClientUser={setClientUser}
        HFuser={HFuser}
        promoRef={promoRef}
        changePrice={changePrice}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        prods={prods}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
        isLocal={isLocal}
        audio={audio}
        stopPlay={stopPlay}
      />
      {showCart && <div></div>}
    </div>
  );
}
export default DescriptionPage;
